import React from 'react'
import { Helmet } from 'react-helmet'

import { useSiteMetadata } from 'hooks'
import { getPaginatedPathSuffix } from 'utils/paginate'

interface Props {
  currentPage: number
  totalPageCount: number
  basePath: string
}

const getPath = (basePath: string, page: number) =>
  `${basePath}${getPaginatedPathSuffix(page)}`

const PaginationMetatags = ({
  currentPage,
  totalPageCount,
  basePath,
}: Props) => {
  const { siteUrl } = useSiteMetadata()
  const isFirstPage = currentPage === 1
  const isLastPage = currentPage === totalPageCount
  const prevPath = !isFirstPage ? getPath(basePath, currentPage - 1) : ''
  const nextPath = !isLastPage ? getPath(basePath, currentPage + 1) : ''
  return (
    <Helmet>
      {prevPath ? <link rel="prev" href={`${siteUrl}${prevPath}`} /> : null}
      {nextPath ? <link rel="next" href={`${siteUrl}${nextPath}`} /> : null}
    </Helmet>
  )
}

export default PaginationMetatags
